export default "__VITE_ASSET__CcL1vp63__"